import { IChipImplementation } from "../chip-types";

export const UnimplementedChip: IChipImplementation<any> = {
  // fixedInputs: [],
  // fixedOutputs: [],
};
